import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { toSnakeCase } from 'case-converter';

import { getRouteUrl } from '@utils/urls';
import request from '@utils/request';
import { isBrowser } from '@utils/environmentCheck';

import { mobileOrderFormSend } from '@common/endpoints';
import { MOBILE_ORDER_SUCCESS } from '@common/routes';
import {
  useMultiStepContext,
  clearMuliStepContextLocalStorage,
} from '@common/contexts/multiStepContext';
import {
  mapFormStateToSend,
  MOBILE_ORDER_FORM_CURRENT_STEP,
  MOBILE_ORDER_FORM_STATE,
  validateAboDetailsStep,
} from '../../MobileOrderForm.helpers';

const useHandleSubmit = (setIsFormSending, formik) => {
  const {
    pathname,
    asPath,
    locale,
    replace,
    push,
    query: { plan },
  } = useRouter();
  const { t } = useTranslation();
  const { handleChangeStep, handleChangeStepsValidity } = useMultiStepContext();

  return async e => {
    e.preventDefault();
    setIsFormSending(true);

    const body = mapFormStateToSend(formik.values);

    try {
      await request.post(mobileOrderFormSend(), body);

      if (isBrowser) {
        localStorage.removeItem(`${MOBILE_ORDER_FORM_STATE}-PLAN-${plan}`);
        clearMuliStepContextLocalStorage(
          `${MOBILE_ORDER_FORM_CURRENT_STEP}-PLAN-${plan}`,
        );
      }

      await push(
        MOBILE_ORDER_SUCCESS,
        getRouteUrl(locale, MOBILE_ORDER_SUCCESS),
      );
    } catch ({ response }) {
      await replace(
        {
          pathname,
          query: {
            friendlyError: t(
              'mobile.orderForm.sendErrorMessage',
              'Etwas ist schief gelaufen. Bitte überprüfen Sie alle Felder des Formulars und versuchen Sie es erneut.',
            ),
          },
        },
        asPath,
      );

      if (response?.data) {
        const data = toSnakeCase(response.data);

        Object.keys(data).forEach(name => {
          if (name === 'error') return;

          const dataName = data[name];

          if (!Array.isArray(dataName)) {
            Object.keys(dataName).forEach(subName => {
              formik.setFieldTouched(`${name}.${subName}`);
              formik.setFieldError(name, dataName[subName][0]);
            });
          } else {
            formik.setFieldTouched(name);
            formik.setFieldError(name, dataName[0]);
          }
        });
      }

      const isAboDetailsStepValid = validateAboDetailsStep(formik);

      handleChangeStepsValidity(1, false);
      handleChangeStepsValidity(0, isAboDetailsStepValid);
      handleChangeStep(isAboDetailsStepValid ? 1 : 0);
    }
    setIsFormSending(false);
  };
};

export default useHandleSubmit;
